<template>
  <RankBox :options="options" />
</template>

<script>
import RankBox from "./rankBox.vue";
export default {
  components: { RankBox },
  data() {
    return {
      options: {
        title: "ยอดซื้อร้านค้าปลีก 10 อันดับ",
        apiPath: "top_sales",
        hName: "ร้าน",
        hValue: "ยอดซื้อ",
        key: "topSales",
        shopType: "retail",
      },
    };
  },
};
</script>